import React, { useState, useEffect } from 'react';
import './AIRollingText.css';

interface AIRollingTextProps {
  message: string;
  agentName?: string;
}

const AIRollingText: React.FC<AIRollingTextProps> = ({ 
  message, 
  agentName = "Aria"
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const typingSpeed = 40; // milliseconds per character

  useEffect(() => {
    // Reset when message changes
    setDisplayedText('');
    setCurrentIndex(0);
  }, [message]);

  useEffect(() => {
    if (currentIndex < message.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + message[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, typingSpeed);

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, message]);

  return (
    <div className="ai-rolling-text">
      <div className="text-container">
        <span className="agent-tag">
          <span className="ai-icon">🤖</span>
          {agentName}:
        </span>
        <span className="rolling-message">
          {displayedText}
          {currentIndex < message.length && <span className="cursor">|</span>}
        </span>
      </div>
    </div>
  );
};

export default AIRollingText;